import { createApp } from '@wu/widget-core';
import { AppointmentBooking } from './appointment-booking';

export default createApp(
  { alias: 'appointment-booking', name: 'Appointment Booking' },
  AppointmentBooking
);
